import { Popconfirm } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";

const ResetButton = () => {
  const navigate = useNavigate();
  return (
    <Popconfirm
      description={
        <>
          <div className="max-w-[300px] p-4">
            <p className="text-[16px] font-semibold leading-[normal] text-black">
              Are you sure you want to reset the job?
            </p>
          </div>
        </>
      }
      okButtonProps={{
        className:
          "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
      }}
      cancelButtonProps={{
        className:
          "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
      }}
      okText="Yes"
      cancelText="No"
      icon={null}
      onConfirm={() => {
        // router.visit(routingConstants.createJob);
        navigate(routingConstants.dashboardRedirect, {
          state: { _for: routingConstants.createJob },
        });
      }}
    >
      <button
        type="button"
        className="ease relative h-[40px] w-[120px] rounded-lg border border-red bg-red text-center text-[14px] font-medium leading-[38px] text-white transition-all duration-200 hover:bg-none hover:text-red"
      >
        Reset
      </button>
    </Popconfirm>
  );
};

export default ResetButton;
